// components/service/AddEditanyModal.tsx

import { useState } from "react";
import useServiceTypes from "../../controllers/serviceMaster/useServiceTypes";

interface Props {
  service: any | null;
  onClose: () => void;
  onSave: (service: any) => void;
}

export function AddEditServiceModal({ service, onClose, onSave }: Props) {
  const { serviceTypes, isLoading } = useServiceTypes();

  const [name, setName] = useState(service?.name ?? "");
  const [type, setType] = useState<string>(
    service?.serviceType ?? "CONSULTATION",
  );
  const [price, setPrice] = useState<number>(service?.defaultPrice ?? 0);

  const handleSubmit = () => {
    if (!name.trim()) return;

    onSave({
      name,
      serviceType: type,
      defaultPrice: price,
    });
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow">
            <div className="modal-body p-4">
              <h5 className="fw-semibold mb-4">
                {service ? "Edit Service" : "Add New Service"}
              </h5>

              {/* Name */}
              <div className="mb-3">
                <label className="form-label small text-muted">
                  Service Name
                </label>
                <input
                  className="form-control"
                  placeholder="e.g. Physiotherapy Session"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              {/* Type */}
              <div className="mb-3">
                <label className="form-label small text-muted">Type</label>

                <select
                  className="form-select"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  disabled={isLoading}
                >
                  {serviceTypes?.map((t) => (
                    <option key={t.type} value={t.type}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label className="form-label small text-muted">
                  Default Price (₹)
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="e.g. 1500"
                  value={price}
                  onChange={(e) => setPrice(Number(e.target.value))}
                />
              </div>

              <div className="d-flex justify-content-end gap-2">
                <button className="btn btn_outline" onClick={onClose}>
                  Cancel
                </button>

                <button className="btn btn_primary px-4" onClick={handleSubmit}>
                  Save Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
